import React, { createContext } from 'react'

type AvatarFallbackColorsProviderProps = {
  enabled: boolean
  children: React.ReactNode
}

export const AvatarFallbackColorsContext = createContext(false)

export const AvatarFallbackColorsProvider: React.FC<
  AvatarFallbackColorsProviderProps
> = ({ enabled, children }) => (
  <AvatarFallbackColorsContext.Provider value={enabled}>
    {children}
  </AvatarFallbackColorsContext.Provider>
)
